export default __webpack_public_path__ + "static/media/2177.b9743e12.png";